<nz-input-group [nzSuffix]="prefixTemplate">
    <input #textInput nz-input [ngModel]="current" readonly (click)="edit()" class="i18n-text" />

</nz-input-group>

<ng-template #prefixTemplate>
    <i nz-icon nzType="global" nzTheme="outline"></i>

</ng-template>
<ng-template cdk-portal #overlayGlobalTemplate="cdkPortal">
    <nz-table class="mm-table" [nzNoResult]="undefined" [style.width]="width" [nzData]="[1]" [nzShowPagination]="false"
        [nzSize]="'small'">
        <thead>
            <tr>
                <!-- <th [nzWidth]="'85px'">{{translations.language | async}}</th>
                <th>{{translations.text | async}}</th> -->
                <th>{{'Common.Language' | translate}}</th>
                <th>{{'Common.Text' | translate}}</th>

            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let cul of cultures">
                <td>{{translations.lang(cul) | async}}</td>
                <td><input type="text" nz-input [ngModel]="getText(cul)" (ngModelChange)="setText(cul,$event)" [maxlength]="maxlength"
                        (keydown)="inputKeydown($event)">
                </td>
            </tr>
        </tbody>
    </nz-table>
</ng-template>
